import React, { useEffect, useRef, useState } from 'react';
import LayoutV2 from '../../../components/layout-v2';
import UInput from "ubs-framework/v2/UInput";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";
import { sendData } from '../../../store/actions';
import useSocket from '../../common/useSocket';
import UPopup from 'ubs-framework/v2/UPopup';
import * as Icon from 'ubs-icons';
import { COLOR, REGEX } from '../../../common/constant';
import { errorFocus, isMobileDevice } from 'ubs-framework/v2/common/function';
import useUAlert from "ubs-framework/v2/UAlert";
import UCheckBox from 'ubs-framework/v2/UCheckBox';
import { checkLowercase, checkMinLength, checkNumeric, checkSpecialCharacter, checkUppercase } from 'ubs-framework/v2/common/function';

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const InvitationRegister = () => {
  const alert = useUAlert();
  const dispatch = useDispatch();
  const history = useHistory();
  const [passwordEye, setPasswordEye] = useState(false)
  const [hide, setHide] = useState(false)
  const [errorMsg, setErrorMsg] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [showTogglePopup, setShowTogglePopup] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [flag, setFlag] = useState("");
  const [invitedData, setInvitedData] = useState(null);
  const [registerDetail, setRegisterDetail] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    cpassword: "",
  });

  const forceUpdate = useForceUpdate()
  const validator = useRef(new Validator({
    element: (message, className) => <div className="u_error_message">{message}</div>,
    autoForceUpdate: { forceUpdate },
    validators: {
      uppercase: {  // name the rule
        message: 'Please use uppercase.',
        rule: (val, params, validator) => {
          return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
        },
      },
      lowercase: {  // name the rule
        message: 'Please use lowercase.',
        rule: (val, params, validator) => {
          return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
        },
      },
      specialcase: {  // name the rule
        message: 'Please use one special character.',
        rule: (val, params, validator) => {
          return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
        },
      },
      number: {  // name the rule
        message: 'Please use one number.',
        rule: (val, params, validator) => {
          return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
        },
      },
    }
  }));

  const { on, off, refresh } = useSocket(res => {
    setDisableBtn(false)
    if (!res.error) {
      switch (res.event) {
        case 'authenticate':
          let path = window.location.pathname.split('/')[2]
          if (path && path === 'invite') {
            const data = { inviteCode: location.pathname.split('/')[3] }
            sendData(dispatch, 'account|invite|info', data);
          }
          break;
        case 'account|invite|info':
          setInvitedData(res.data)
          if (res.data.isUserExists) {
            setFlag("accept")
          } else if (typeof res.data.isUserExists === 'boolean' && !res.data.isUserExists) setFlag("register")
          else {
            setFlag("wrong")
          }
          dispatch({ type: 'SET_EMAIL', payload: res.data.email });
          break;
        case 'account|invite|accept':
          history.push("/workspace")
          break;
        default:
          return true;
      }
    } else {
      setAlertMsg(res.data.error)
    }
  })

  useEffect(() => {
    if (invitedData?.email) {
      setTimeout(() => {
        setRegisterDetail((val) => {
          return { ...val, email: invitedData?.email || '' }
        })
      }, 1000);
    }
    return () => {
    }
  }, [invitedData])

  useEffect(() => {
    if (alertMsg?.length > 0) {
      alert.show({title:'Oops...!', description: alertMsg})
    }
  }, [alertMsg])

  useEffect(() => {
    const data = { inviteCode: location.pathname.split('/')[3] }
    sendData(dispatch, 'account|invite|info', data);
    on();
    return () => off();
  }, [])

  const inputEvent = (e) => {
    let { name, value } = e.target
    setRegisterDetail((val) => {
      return { ...val, [name]: value }
    })
  }

  const handleToggle = () => {
    setToggle(!toggle)
    if(!toggle) {
      setErrorMsg('')
    } else {
        setErrorMsg('Please agree with Terms & Conditions and Privacy Policy')
    }
  }

  const acceptInvitation = (flag) => {
    if(validator?.current?.allValid() && (flag === "register" ? ((registerDetail?.password === registerDetail?.cpassword) && toggle) : true)) {
      let data = { email: registerDetail?.email, inviteCode: location.pathname.split('/')[3] }
      if (flag === "register") {
        data.firstName = registerDetail?.firstName
        data.lastName = registerDetail?.lastName
        data.password = registerDetail?.password
      }
      sendData(dispatch, 'account|invite|accept', data);
    } else {
      if (registerDetail?.cpassword !== registerDetail?.password) {
        setErrorMsg('Password and confirm password does not match')
      } else if (flag === "register" && !toggle) {
        setErrorMsg('Please agree with Terms & Conditions and Privacy Policy')
      } else {
        setErrorMsg('')
      }
      validator?.current?.showMessages()
      errorFocus();
    }
  }

  return (
    <React.Fragment>
      <LayoutV2 module="">
        <div className="u_p-24">
          <div>
            <h4 className="u_title u_text-center u_text-bold u_mb-12">Invitation Register</h4>
            <p className="u_small-font u_text-center u_mb-24">You are invited to join a new organization. {flag === "accept" ? 'Please accept the invitation to continue' : 'Please create an account to continue'}.</p>

            {flag === "register" && <div className="u_row">
              <div className="u_col-6">
                <UInput
                  hasError={validator?.current?.message("firstName", registerDetail?.firstName, "required")}
                  className="u_mb-20"
                  label="First Name"
                  asterisk
                  testId={TEST_ID.INVITATION_REGISTER.INPUT_WRAPPER}>
                  <input
                    name="firstName"
                    value={registerDetail?.firstName}
                    onChange={inputEvent}
                    placeholder=" "
                    autoComplete="off"
                    data-testid={TEST_ID.INVITATION_REGISTER.FIRST_NAME_INPUT} />
                </UInput>
              </div>

              <div className="u_col-6">
                <UInput
                  hasError={validator?.current?.message("lastName", registerDetail?.lastName, "required")}
                  className="u_mb-20"
                  label="Last Name"
                  asterisk
                  testId={TEST_ID.INVITATION_REGISTER.INPUT_WRAPPER}>
                  <input
                    name="lastName"
                    value={registerDetail?.lastName}
                    onChange={inputEvent}
                    placeholder=" "
                    autoComplete="off"
                    data-testid={TEST_ID.INVITATION_REGISTER.LAST_NAME_INPUT} />
                </UInput>
              </div>

              <div className="u_col-12">
                <UInput
                  hasError={validator?.current?.message("email", registerDetail?.email, "required|email")}
                  className="u_mb-20"
                  label="Email Address"
                  asterisk
                  testId={TEST_ID.INVITATION_REGISTER.INPUT_WRAPPER}>
                  <input
                    name="email"
                    value={registerDetail?.email}
                    onChange={inputEvent}
                    placeholder=" "
                    autoComplete="new-email"
                    disabled
                    data-testid={TEST_ID.INVITATION_REGISTER.EMAIL_INPUT} />
                </UInput>
              </div>

              <div className="u_col-12">
                <UInput
                  className="u_mb-20"
                  password
                  label="New Password"
                  asterisk
                  hasError={validator?.current?.message("password", registerDetail?.password, "required|min:8|uppercase|lowercase|specialcase|number")}
                  testId={TEST_ID.INVITATION_REGISTER.INPUT_WRAPPER}>
                  <input
                    onChange={inputEvent}
                    value={registerDetail.password}
                    type={`${passwordEye ? "text" : "password"}`}
                    autoComplete="new-password"
                    name="password"
                    placeholder=" "
                    data-testid={TEST_ID.INVITATION_REGISTER.PASSWORD_INPUT} />
                  <div className="u_input-note u_ib">
                    <UPopup params={{ className: "u_tooltip u_tooltip-full", disabled: isMobileDevice() }}
                      desc={<span>{!passwordEye ? "Show Password" : "Hide Password"} </span>}>

                      <span className="u_rollover u_cp u_flex" onClick={() => setPasswordEye(!passwordEye)} data-testid={TEST_ID.INVITATION_REGISTER.PASSWORD_TOGGLE} >{!passwordEye ?
                        <Icon.HideEye size={18} fill={COLOR.u_icon_bg} /> :
                        <Icon.Eye size={18} fill={COLOR.u_icon_bg} />}</span>
                    </UPopup>
                  </div>
                </UInput>
              </div>
              <div className="u_col-12">
                <UInput
                  className="u_mb-20"
                  label="Confirm Password"
                  password
                  asterisk
                  hasError={validator?.current?.message('ConfirmPassword', registerDetail?.cpassword, 'required|min:8|uppercase|lowercase|specialcase|number')}
                  testId={TEST_ID.INVITATION_REGISTER.INPUT_WRAPPER}>
                  <input
                    onChange={inputEvent}
                    value={registerDetail?.cpassword}
                    name="cpassword"
                    type={`${hide ? 'text' : 'password'}`}
                    autoComplete="new-password"
                    placeholder=" "
                    data-testid={TEST_ID.INVITATION_REGISTER.CONFIRM_PASSWORD_INPUT} />
                  <div className="u_input-note u_ib">
                    <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                      desc={<span>{!hide ? 'Show Password' : 'Hide Password'} </span>}>

                      <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)} data-testid={TEST_ID.INVITATION_REGISTER.PASSWORD_TOGGLE} >{!hide ?
                        <Icon.HideEye size={18} fill={COLOR.u_icon_bg} /> :
                        <Icon.Eye size={18} fill={COLOR.u_icon_bg} />}</span>
                    </UPopup>
                  </div>
                </UInput>
              </div>
            </div>}

            {flag === "register" && <div className={`u_reset-content ${errorMsg ? 'u_mb-0' : 'u_mb-10'}`}>
              <ul className="u_flex u_flex-wrap">
                <li style={{ color: `${checkMinLength(registerDetail.password, 8) ? '#60B158' : '#8F95A6'}` }}>
                  <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                    fill={`${checkMinLength(registerDetail.password, 8) ? '#60B158' : '#8F95A6'} `} />Minimum
                  8 Characters
                </li>
                <li style={{ color: `${checkUppercase(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                  <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                    fill={`${checkUppercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />Uppercase
                </li>
                <li style={{ color: `${checkLowercase(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                  <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                    fill={`${checkLowercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />Lowercase
                </li>
                <li style={{ color: `${checkNumeric(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                  <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                    fill={`${checkNumeric(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />1
                  Numeric Number
                </li>
                <li style={{ color: `${checkSpecialCharacter(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                  <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                    fill={`${checkSpecialCharacter(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />1
                  Special Character
                </li>
              </ul>
            </div>}

            {flag === "register" && <div className="u_mb-20 u_flex u_terms-conditions">
              <UPopup showDefault={showTogglePopup} params={{ className: "u_tooltip" }}
                desc={<span>Please agree with Terms & Conditions and Privacy Policy</span>}>
                <span><UCheckBox
                  id="123"
                  label=""
                  checked={toggle}
                  onChange={handleToggle}
                  testId={TEST_ID.INVITATION_REGISTER.CHECKBOX} /></span></UPopup>
              <p
                className="u_small-font">Agree
                with <a
                href="https://superworks.com/terms-and-conditions"
                target="_blank"
                className="u_small-font"
                data-testid={TEST_ID.INVITATION_REGISTER.LINK}>Terms & Condition </a> and <a
                href="https://superworks.com/privacy-policy"
                target="_blank"
                className="u_small-font"
                data-testid={TEST_ID.INVITATION_REGISTER.LINK}> Privacy Policy</a></p>
            </div>}

            {errorMsg?.length !== 0 && (
              <p className="u_error-message u_mb-15">{errorMsg}</p>
            )}

            {flag === "register" && <div className="u_block u_relative">
              <button
                disabled={disableBtn}
                type="button"
                onClick={() => acceptInvitation(flag)}
                className={`u_acc-btn u_w-full u_cp`}
                data-testid={TEST_ID.INVITATION_REGISTER.BUTTON}>Register
              </button>
              {disableBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
            </div>}

            {flag === "accept" && <>
              <div className="u_sendmail-section u_t-center u_mt-50">
                <span className="u_sendmail-icon u_ib u_relative">
                  <img className="u_tnkuRound" src="/images/images/u-tnkuRound.png" alt="Round" />
                  <img className="u_emailIcon" src="/images/images/roundLogo.png" alt="emailIcon" />
                  <img className="u_tnkuLine" src="/images/images/u-tnkuLine.png" alt="Line" />
                </span>
              </div>
              <button
                onClick={() => acceptInvitation(flag)}
                className="u_acc-btn u_w-full u_cp"
                data-testid={TEST_ID.INVITATION_REGISTER.BUTTON}>
                Accept Invitation
              </button>
            </>}
          </div>
        </div>
      </LayoutV2>
    </React.Fragment>
  );
};

export default InvitationRegister;
